module.exports = __webpack_public_path__ + "static/media/TVs Categorie.c1a4a026.jpg";